import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import { SessionStatus } from './SessionStatus';
import { Vendor } from './Vendor';

const LOG = LoggerFactory.create('getWebcastLink');

const getWebcastLink = (sessionStatus, links, vendor, format) => {
  let webcastLink;
  const attendee = links?.attendee;
  const join = links?.join;
  const recording = links?.recording;
  switch (sessionStatus) {
    case SessionStatus.AFTER:
      // if vendor has separate join and recording links and session is over, always use recording link, even if null
      webcastLink = recording;
      break;
    default:
      if (
        format === 'Pre_recorded' &&
        (vendor === Vendor.VIMEO || vendor === Vendor.WEBLINK)
      ) {
        // HUB-423: For these vendors and 'pre-recorded' format, default to use the recording webcast link
        webcastLink = attendee?.href ? attendee : recording;
      } else {
        webcastLink = attendee?.href ? attendee : join;
      }
  }
  if (!webcastLink) {
    // if webcast link is null or empty, return it without performing URL validation
    return webcastLink;
  }
  try {
    new URL(webcastLink?.href); // Throws exception if string is not a valid URL
    return webcastLink;
  } catch (error) {
    LOG.warn(
      `The webcast/recording URL "${webcastLink?.href}" is not a valid URL.`
    );
    return null;
  }
};

export default getWebcastLink;
